/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sms_Delivery_FailedInputs */

const cs_error_sms_delivery_failed = /** @type {(inputs: Error_Sms_Delivery_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS se nepodařilo odeslat. Zkuste to znovu, nebo kontaktujte podporu.`)
};

const en_error_sms_delivery_failed = /** @type {(inputs: Error_Sms_Delivery_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SMS delivery failed. Please try again or contact support.`)
};

/**
* | output |
* | --- |
* | "SMS delivery failed. Please try again or contact support." |
*
* @param {Error_Sms_Delivery_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const error_sms_delivery_failed = /** @type {((inputs?: Error_Sms_Delivery_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sms_Delivery_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_sms_delivery_failed(inputs)
	return cs_error_sms_delivery_failed(inputs)
});